
<dn-modal
    name="assignment-created"
    position="centered"
    size="small"
>
    <modal-content class="modal-content--centered">
        <h1>{{ $t('modal.assignment-created.title') }}</h1>

        <p>{{ $t('modal.assignment-created.description') }}</p>

        <p>
            <button
                class="btn btn--secondary"
                @click="$store.dispatch('modal/closeModal');"
            >
                {{ $t('modal.assignment-created.cta') }}
            </button>
        </p>
    </modal-content>
</dn-modal>
